import type { FunctionComponent } from 'react';

type HeaderProps = {
  currentStep: number;
  onActionClick: () => void;
};

const Header: FunctionComponent<HeaderProps> = ({
  currentStep = 0,
  onActionClick = () => null,
}) => (
  <>
    <h1 className="preferences-title">Email Preferences</h1>
    <div className="preferences-menu">
      <h2 className="preferences-menu-title">Manage Notifications</h2>
      <button className="edit" type="button" onClick={onActionClick}>
        {currentStep === 0 ? 'EDIT' : 'CANCEL'}
      </button>
    </div>
    <div className="divider" />
  </>
);

export default Header;
